import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesReturns } from "../../constants";

export const requestApproveReturn = async (orderId: string): Promise<void> => {
  return await instance.put(buildUrl(ApiRoutesReturns.ApproveReturn, orderId));
};
